import type { OrdersV2 } from '@/api/ordersV2/types';
import ResultPage, { ResultPageStatusEnum } from '@/components/result-page';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { NoticeBar } from '@hb/coffee';
import ApplyContentDetails from '../apply-content';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'ApplyProcessDetails' })
export default class ApplyProcessDetails extends Vue {
  @Prop()
  private orderDetail!: OrdersV2.OrderDetail;

  @Prop()
  private commodityDetail!: OrdersV2.CommodityDetail;

  @Prop()
  private isLentOrPayoff!: boolean;

  private render() {
    return (
      <div class={style.ApplyProcessDetails}>
        {this.orderDetail.isStockUpReminder && (
          <div class={style.fixedNoticeBar} >
            <NoticeBar
              text={this.orderDetail.stockUpReminderText}
              scrollable
              show-arrow={false}
            />
          </div>
        )}
        <div style={{ paddingTop: this.orderDetail.isStockUpReminder ? '40px' : '0' }}>
          <ResultPage
            title="提现申请中"
            status={ResultPageStatusEnum.PROCESS}
            productIcon={this.commodityDetail && this.commodityDetail.icon}
            amount={this.orderDetail.amount}
          >
            <ApplyContentDetails
              orderDetail={this.orderDetail}
              commodityDetail={this.commodityDetail}
              isLentOrPayoff={this.isLentOrPayoff}
            />
          </ResultPage>
      </div>
        </div>
    );
  }
}
